import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class TDSModal extends Vue {
    @Prop({type: Number, default: 474}) readonly width: number | undefined;
    @Prop({type: Boolean, default: false}) readonly draggable: boolean | undefined;
    @Prop({type: Boolean, default: false}) readonly hideCloseButton: boolean | undefined;
    @Prop({type: Boolean, default: false}) readonly darkMode: boolean | undefined;

    private componentId: string = "oc" + Math.random().toString(36).substr(2, 6);
    private pointerDownStartedInsideModal: boolean = false;
    private dragged: boolean = false;
    private isDragging: boolean = false;
    private mousePositionX: number = 0;
    private mousePositionY: number = 0;
    private offsetX: number = 0;
    private offsetY: number = 0;
    private visible: boolean = false;
    private readonly onPointerDownCaptureBound: (event: PointerEvent) => void = (event: PointerEvent) => this.onPointerDownCapture(event);
    private readonly onPointerUpCaptureBound: (event: PointerEvent) => void = (event: PointerEvent) => this.onPointerUpCapture(event);
    private readonly onEscapeKeyPressBound: (event: KeyboardEvent) => void = (event: KeyboardEvent) => this.onEscapeKeyPress(event);

    mounted () {
        this.$nextTick(() => {
            document.body.style.position = "fixed";
            setTimeout(() => {
                this.visible = true;
            }, 100);
        });

        //  Necessary to unbind from opening click!
        setTimeout(() => {
            document.addEventListener("pointerdown", this.onPointerDownCaptureBound, true);
            document.addEventListener("pointerup", this.onPointerUpCaptureBound, true);
            document.addEventListener("keyup", this.onEscapeKeyPressBound);
        }, 100);
    }

    beforeDestroy () {
        document.body.style.position = "relative";
        this.visible = false;
        document.removeEventListener("pointerdown", this.onPointerDownCaptureBound, true);
        document.removeEventListener("pointerup", this.onPointerUpCaptureBound, true);
        document.removeEventListener("keyup", this.onEscapeKeyPressBound);
    }

    public handleScrollerMouseDown (event: MouseEvent): void {
        if (!this.draggable) return;
        this.isDragging = true;
        this.mousePositionX = event.screenX - this.offsetX;
        this.mousePositionY = event.screenY - this.offsetY;
    }

    public handleScrollerMouseMove (event: MouseEvent): void {
        if (this.isDragging) {
            this.dragged = true;
            this.offsetX = event.screenX - this.mousePositionX;
            this.offsetY = event.screenY - this.mousePositionY;
        }
    }

    public onEscapeKeyPress (event: KeyboardEvent): void {
        event = event || window.event;
        let isEscape: boolean = false;
        if ("key" in event) {
            isEscape = event.key === "Escape" || event.key === "Esc";
        }
        if (isEscape) {
            this.isDragging = false;
            this.$emit("close", true);
        }
    }

    public onPointerDownCapture (event: PointerEvent): void {
        if (event.button !== 0) return;
        this.pointerDownStartedInsideModal = this.isEventInsideModal(event);
    }

    public onPointerUpCapture (event: PointerEvent): void {
        if (event.button !== 0) return;
        this.isDragging = false;

        const upInsideModal = this.isEventInsideModal(event);
        if (!this.pointerDownStartedInsideModal && !upInsideModal) {
            this.$emit("close", true);
        }

        this.pointerDownStartedInsideModal = false;
    }

    private isEventInsideModal (event: PointerEvent): boolean {
        const path = typeof event.composedPath === "function" ? event.composedPath() : [];
        const modalElement = document.getElementById(this.componentId);
        if (modalElement && path.includes(modalElement)) {
            return true;
        }

        const target = event.target as HTMLElement | null;
        return !!target?.closest("#" + this.componentId);
    }
}
